package game.controller

import game.Game
import view.Terminal

class TitleScroll(game: Game, val width: Int) {
    private var pos = 0

    private val buffer = Terminal(game.font, 200, 10)

    init {
        var room = game.getRoomById("title-bg-1")
        room.render(buffer, 0, 0, 0, 0, 50, 10)
        room.render(buffer, 50, 0, 0, 10, 50, 10)
        room = game.getRoomById("title-bg-2")
        room.render(buffer, 100, 0, 0, 0, 50, 10)
        room.render(buffer, 150, 0, 0, 10, 50, 10)
    }

    fun scrollLeft() {
        pos--

        if (pos < 0) {
            pos = buffer.cols-1
        }
    }

    fun scrollRight() {
        pos++

        if (pos >= buffer.cols) {
            pos = 0
        }
    }

    fun render(terminal: Terminal, col: Int, row: Int) {
        val split = buffer.cols - pos

        if (pos < buffer.cols - width) {
            terminal.copy(buffer, col, row, pos, 0, width, 10)
        } else {
            terminal.copy(buffer, col, row, pos, 0, split, 10)
            terminal.copy(buffer, col + split, row, 0, 0, width - split, 10)
        }
    }
}